const getBidSales = (responsePayload = {}) => responsePayload?.data?.bid_sales;

export const getOfferRefreshV4SummaryArray = (responsePayload = {}) => {
	const summary = getBidSales(responsePayload)?.summary;

	if (summary && typeof summary === 'object') {
		return Object.entries(summary).map(([bidSaleId, summaryValue]) => {
			const normalizedBidSaleId = Number(bidSaleId);
			return {
				...summaryValue,
				bid_sale_id: Number.isNaN(normalizedBidSaleId) ? bidSaleId : normalizedBidSaleId,
			};
		});
	}
	return null;
};

export const getOfferRefreshV4RefreshMap = (responsePayload = {}) => {
	return getBidSales(responsePayload)?.refresh || {};
};

export const normalizeVehicleWithOfferRefreshV4 = ({ offerData, existingVehicleData }) => ({
	...existingVehicleData,
	offerData: offerData,
	version: offerData?.version || existingVehicleData?.version,
});

export const normalizeVehiclesWithOfferRefreshV4 = ({ vehicles = [], responsePayload = {} }) => {
	const refreshMap = getOfferRefreshV4RefreshMap(responsePayload);

	const vehicleLists =
		vehicles?.length ? vehicles : (
			Object.keys(refreshMap).map((vehicleBidSaleId) => ({ bid_sale_id: Number(vehicleBidSaleId) }))
		);

	return vehicleLists.map((vehicle) => {
		const bidSaleId = String(vehicle?.bid_sale_id ?? '');
		const newStruct = refreshMap?.[bidSaleId];
		if (!newStruct) return vehicle;
		return normalizeVehicleWithOfferRefreshV4({ offerData: newStruct, existingVehicleData: vehicle });
	});
};
